import { render, staticRenderFns } from "./SelectedStores.vue?vue&type=template&id=4036139b"
import script from "./SelectedStores.vue?vue&type=script&lang=js"
export * from "./SelectedStores.vue?vue&type=script&lang=js"
import style0 from "./SelectedStores.vue?vue&type=style&index=0&id=4036139b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports